import { createAction } from 'redux-actions';

export const updateProfileRequest = createAction('UPDATE_PROFILE_REQUEST');
export const updateProfileEndRequest = createAction('UPDATE_PROFILE_END_REQUEST');



// WEBPACK FOOTER //
// ./src/redux/actions/profile-settings.js